import { Component, inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthShared } from 'src/app/auth/auth-shared.abstract';
import { promiseWithCatch } from 'src/app/common/app.helpers';
import { OperationInfoService } from 'src/app/common/long-operations/operation-info.service';
import { RecoveryPassowordForm } from '../auth-form.inteface';

@Component({
  selector: 'app-recovery-password',
  templateUrl: './recovery-password.component.html',
  styleUrls: ['./recovery-password.component.scss'],
})
export class RecoveryPasswordComponent extends AuthShared<RecoveryPassowordForm> implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private operationService = inject(OperationInfoService);

  public override ngOnInit(): void {
    super.ngOnInit();
    this.validateResetPasswordToken();
  }

  public validateResetPasswordToken(): void {
    this.authService.validateResetPasswordToken(this.extractToken());
  }

  public submitRecovery(): void {
    if (this.form.invalid) {
      this.validateAllFields();
      return;
    }

    this.operationService.setupOperation({ successfulMessage: 'RECOVERY_PASSWORD_VERIFICATION_DIALOGUE_BODY' }, () => {
      this.authService.recoverPassword(this.form.value.password, this.extractToken());
    });
  }

  public extractToken(): string {
    return this.route.snapshot.queryParams['email'] as string;
  }

  protected initializeForm(): void {
    if (!this.extractToken()) {
      promiseWithCatch(this.router.navigateByUrl('/login'));
      return;
    }

    this.form = new FormGroup(
      {
        password: new FormControl('', this.validationService.getValidators('password')),
        repeatPassword: new FormControl('', this.validationService.getValidators('repeatPassword')),
      },

      this.validationService.getFormPasswordValidators(),
    );

    this.validateRepeatPasswordChanges();
  }
}
